import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api'
});

// 添加请求拦截器
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// 添加响应拦截器
api.interceptors.response.use(
  (response) => response,
  (error) => {
    // 如果收到 401 错误（未授权），可能是令牌过期
    if (error.response?.status === 401) {
      // 清除本地存储的认证信息
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      
      // 重定向到登录页面
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export const resumeApi = {
  save: async (data) => {
    const response = await api.post('/resumes', data);
    return response.data;
  },
  
  update: async (id, data) => {
    const response = await api.put(`/resumes/${id}`, data);
    return response.data;
  },
  
  get: async (id) => {
    const response = await api.get(`/resumes/${id}`);
    return response.data;
  },
  
  list: async () => {
    const response = await api.get('/resumes');
    return response.data;
  }
};

export const authApi = {
  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    return response.data;
  },
  
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    return response.data;
  }
}; 